import React from 'react';

import { Flexbox, FontAwesomeIcon, Button } from '@schoolinks/ui-components';
import { useSelector, useDispatch } from 'react-redux';

import { faBackwardStep } from '@fortawesome/pro-solid-svg-icons/faBackwardStep';
import { faForwardStep } from '@fortawesome/pro-solid-svg-icons/faForwardStep';
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faVolumeXmark } from '@fortawesome/pro-solid-svg-icons/faVolumeXmark';

import { ensureArray } from 'utils/arrays';

import { TTS_PLAY_ALL, TTS_STOP } from 'modules/ElementaryCareers/constants';

import useStopPlayingReadAloud from 'modules/ElementaryCareers/hooks/useStopPlayingReadAloud';
import { SET_TTS_DATA } from 'modules/ElementaryCareers/store/actionTypes';

import s from './TextToSpeechPlayAll.css';

const TextToSpeechPlayAll = () => {
  const dispatch = useDispatch();
  const { playingItem, ttsEnabledItems, isPlaying } = useSelector(
    state => state?.textToSpeech,
  );

  const stopPlayingReadAloud = useStopPlayingReadAloud();

  const toggleTts = () => {
    if (isPlaying) {
      stopPlayingReadAloud();
    }
    dispatch({
      type: SET_TTS_DATA,
      payload: { playingItem, ttsOption: TTS_PLAY_ALL, isPlaying: !isPlaying },
    });
  };

  const cancelTts = () => {
    stopPlayingReadAloud();
    dispatch({
      type: SET_TTS_DATA,
      payload: { playingItem: -1, ttsOption: TTS_STOP, isPlaying: false },
    });
  };

  const setNextPlayingItem = () => {
    if (playingItem < ensureArray(ttsEnabledItems).length - 1) {
      stopPlayingReadAloud();
      dispatch({
        type: SET_TTS_DATA,
        payload: { playingItem: playingItem + 1, isPlaying: true },
      });
    }
  };

  const setPrevPlayingItem = () => {
    if (playingItem !== -1) {
      stopPlayingReadAloud();
      dispatch({
        type: SET_TTS_DATA,
        payload: { playingItem: playingItem - 1, isPlaying: true },
      });
    }
  };

  return (
    <Flexbox alignItems="center" className={s.root}>
      <Button
        className={s.button}
        size="small"
        tooltipProps={{
          title: 'Go back one item',
          placement: 'bottom',
        }}
        compactVariant="default"
        onClick={setPrevPlayingItem}
        color="secondary"
        variant="outlined"
        hasWhiteBackground={false}
        icon={<FontAwesomeIcon icon={faBackwardStep} />}
      />
      <Button
        className={s.button}
        size="small"
        tooltipProps={{
          title: isPlaying ? 'Pause' : 'Play',
          placement: 'bottom',
        }}
        compactVariant="default"
        onClick={toggleTts}
        color="secondary"
        variant="outlined"
        hasWhiteBackground={false}
        icon={<FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />}
      />
      <Button
        className={s.button}
        size="small"
        tooltipProps={{
          title: 'Play next item',
          placement: 'bottom',
        }}
        compactVariant="default"
        onClick={setNextPlayingItem}
        color="secondary"
        variant="outlined"
        hasWhiteBackground={false}
        icon={<FontAwesomeIcon icon={faForwardStep} />}
      />
      <Button
        className={s.button}
        size="small"
        tooltipProps={{
          title: 'Stop reading',
          placement: 'bottom',
        }}
        compactVariant="default"
        onClick={cancelTts}
        color="secondary"
        variant="outlined"
        hasWhiteBackground={false}
        icon={<FontAwesomeIcon icon={faVolumeXmark} />}
      />
    </Flexbox>
  );
};

export default TextToSpeechPlayAll;
